export enum LoanApplicationSource {
    GENERIC = 'GENERIC', PRE_APPROVAL = 'PRE_APPROVAL'
}
